import { __ } from "../lang/translator";

class SearchClass {
  constructor() {
    // 固定検索パラメーター
    this.defaltData = {
      'prefecture': document.querySelector(['[data-current-prefecture]'])?.getAttribute('data-current-prefecture') ?? defaultPrefecture,
    };
    // リセットタイム
    this.resetTime = false;

    // 検索結果モード
    this.result = false;
    // マップ検索モード
    this.map = false;

    // 件数表示要素
    this.CountViewData = "[data-search-result-count-field]"
    // 件数単位表示要素
    this.CountViewCase = "[data-modal-office-count-case]"

    // サブミットのname属性値
    this.searchSubmitName = "searchSubmit";
    // リセットのname属性値
    this.searchResetName = "searchReset";

    // 件数取得APIのエンドポイント
    this.countApiEndPoint = route('web.search.map.count');

    // 条件タグの削除イベント
    this.searchTagDeleteEvent = new Event('search-tag-delete');

    // setTimeoutの返り値をセットする変数を用意
    // this.scrollTimer = false;
  }

  /* 設定 */
  searchConfig() {
    const searchConfig = {
      parameter: {
        comment_publish_flag:  { type: 'plain', label: 'プロのオススメ物件' },
        campaign_publish_flag: { type: 'plain', label: 'キャンペーンあり' },
        layout_flag:           { type: 'plain', label: '間取り図あり'  },
        vr_flag:               { type: 'plain', label: 'VRあり' },
        meeting_room_flag:     { type: 'plain', label: '会議室' },
        phone_booth_flag:      { type: 'plain', label: '電話ブース' },
        manned_reception_flag: { type: 'plain', label: '有人受付あり' },
        lounge_flag:           { type: 'plain', label: '共有ラウンジ' },
        capacity_category:     { type: 'array', label: '想定人数' },
        budget_category:       { type: 'array', label: '予算検索' },
        service_brand:         { type: 'array', label: 'サービス' },
      }
    }
    return searchConfig;
  }

  /* 件数取得APIの実行と表示 */
  async countApi(data){
    // 件数表示要素
    const searchResultCountField = document.querySelectorAll(this.CountViewData)
    const searchResultCountCases = document.querySelectorAll(this.CountViewCase)
    if(!searchResultCountField.length){ return false; }
    // 初期化(ローディング処理)
    searchResultCountField.forEach(function(elm) {
      elm.innerHTML = "Loading...";
      elm.classList.add('is-loading');
    });
    // Ajax
    return await axios.get(this.countApiEndPoint, {params: data})
    .then(response => {
      // 成功
      searchResultCountField.forEach(function(elm) {
        elm.innerHTML = response.data.toLocaleString();
        elm.classList.remove('is-loading');
      });
      searchResultCountCases.forEach(elm => {
        elm.innerHTML = __('cases_found', response.data);
      })
      return response.data.toLocaleString();
    })
    .catch(error => {
      // 失敗
      console.error(error);
      return "Loading.....";
    })
  }

  /* 件数取得APIのセットタイムアウト処理 */
  count (data=[]) {
    // 他の関数呼び出し用
    const self = this;
    // 件数表示要素
    const searchResultCountField = document.querySelectorAll(this.CountViewData)
    if(!searchResultCountField.length){ return false; }

    // scrollTimerにすでに返り値がセットされていれば、clearTimeoutを実行して、実行待ちの処理をリセットする
    if (typeof(this.scrollTimer) == 'undefined'){
      this.scrollTimer = false;
    }
    if (this.scrollTimer !== false) {
      clearTimeout(this.scrollTimer);
    }

    // setTimeoutを実行
    this.scrollTimer = setTimeout(() => {
      self.countApi(data)
    }, 1000);
  }

  /* 検索ボタンクリック */
  searchSubmit (name=this.searchSubmitName,data=[]) {
    // 他の関数呼び出し用
    const self = this;
    $(document).on('click', '[name='+name+']', function () {

      // 入力値取得
      const queryParameter = self.getInput();

      // 固定で送りたいものなどある場合。
      if(Object.keys(data).length){
        for (let [key, value] of Object.entries(data)) {
          if(value){
            queryParameter[key]=value;
          }else{
            // 空の場合
            if(typeof queryParameter[key] != undefined){
              delete queryParameter[key];
            }
          }
        };
      }

      const urlSearchParam = new URLSearchParams(queryParameter).toString();
      // 検索ページに遷移
      document.location.href = location.pathname +'?'+ urlSearchParam;
    });
  }

  /* リセット処理 */
  resetInput (range=[]){
    // 他の関数呼び出し用
    const self = this;
    // 設定データ
    const objectFormData = self.searchConfig().parameter;
    // リセット範囲指定
    let objectResetInput = [];
    if(range.length){
      // リセット範囲指定がある場合
      for (let i=0; i<range.length; i++) {
        // リセット範囲指定した配列のみ格納
        objectResetInput[range[i]] = objectFormData[range[i]];
      }
    }else{
      objectResetInput = objectFormData;
    }

    // 設定データ繰り返し処理
    for (let key in objectResetInput){
      // name属性の値を作成
      let inputName = '';
      if(objectResetInput[key].type=='array'){
        // 配列の場合、[]を追加
        inputName = key + '[]';
      }else{
        inputName = key;
      }
      // 該当のname属性を持つ要素の繰り返し処理
      $('[name^="' + inputName + '"]').each(function (n, e) {
        // タイプで識別
        switch($(e).attr('type')){
            case 'checkbox':
              if($(e).prop('checked')){
                $(e).prop('checked', false).trigger('change');
              }
              break;
            case 'select-one':
              if($(e).val()&&$(e).val()!='__unselected'){
                $(e).val('__unselected').trigger('change');
              }
              break;
            case 'radio':
              if($(e).prop('checked')){
                $(e).prop('checked', false).trigger('change');
              }
              break;
            case 'text':
              if($(e).val()){
              }
              break;
            default:
              if(self.result && key == "prefecture_id"){
                // 検索結果モード && prefecture_idがある場合 => リセット
                $(e).val('').trigger('change');
              }
              break;
        };
      });
    }
    return;
  }

  /* リセットボタンクリックイベント */
  searchReset (name=this.searchResetName){
    // 他の関数呼び出し用
    const self = this;
    // リセットボタンクリックイベント
    $(document).on('click', '[name="'+name+'"]', function () {
      // リセット範囲設定
      let range = [];//全部

      // リセット開始
      self.resetTime = true;
      // リセット処理
      self.resetInput(range)
      // リセット終了
      self.resetTime = false;
      // カウント開始
      self.count(self.defaltData);

      // マップワード
      if(name=="mapReset"&&$('[name="map_word"]').val()){
        $('[name="map_word"]').val('')
      }
    });
  }

  /* タグ追加 */
  appendSearchTag (name,label,value,type) {
    // 他の関数呼び出し用
    const self = this;
    // データ取得
    const objectFormData = self.searchConfig().parameter[name]
    // タグフィールド
    const searchSelectTagField = document.getElementById('search-select-tag-field');
    searchSelectTagField.scrollTo(0, searchSelectTagField.scrollHeight);//スクロール箇所を最下部に
    // タグの色(class)
    const color = objectFormData.color ? objectFormData.color : '';

    // タグ要素
    const tagHtmlElement = document.createElement("button");
    tagHtmlElement.type = "button";
    tagHtmlElement.className = "c-button05 " + color;
    tagHtmlElement.dataset.nameLabel = name+':'+value;

    // テキスト要素
    const tagHtmlTextElement = document.createElement("span");
    tagHtmlTextElement.className = "c-button05__text";
    tagHtmlTextElement.innerHTML = label;

    // バツ要素
    const tagHtmlCloseElement = document.createElement("span");
    tagHtmlCloseElement.className = "c-button05__close tagHtmlCloseElement";

    // テキスト要素をタグ要素に挿入
    tagHtmlElement.appendChild(tagHtmlTextElement);
    // バツ要素をタグ要素に挿入
    tagHtmlElement.appendChild(tagHtmlCloseElement);
    // タグ要素をタグフィールドに挿入
    searchSelectTagField.appendChild(tagHtmlElement);

    // タグの削除イベントを登録
    tagHtmlElement.addEventListener('click', () => {
      let inputName = name
      if(objectFormData.type=='array') {
        inputName = inputName + '[]';
      }

      // checkboxを解除
      const closeCheckboxElement = $('[name="' + inputName + '"][value=' + value + ']');
      closeCheckboxElement.prop('checked', false).trigger('change');
      closeCheckboxElement.each(function (n, e) {
        self.occurChangeEvent(name,e);
      });
    })
  };

  /* タグ削除 */
  removeSearchTag (name,label,value) {
    // 他の関数呼び出し用
    const self = this;
    // タグフィールド
    const searchSelectTagField = document.getElementById('search-select-tag-field');
    // 要素取得
    let dataNameLabel = "";
    dataNameLabel = searchSelectTagField.querySelector('[data-name-label="'+name+':'+value+'"]');
    // 削除
    if(dataNameLabel) {
      dataNameLabel.remove();

      // タグの削除イベントを発火
      window.dispatchEvent(this.searchTagDeleteEvent);
    }
  };

  /* フォーム変更イベント */
  occurChangeEvent (name,element) {
    // 他の関数呼び出し用
    const self = this;
    // 設定データにあるか
    if(typeof self.searchConfig().parameter[name] != undefined){
      // 設定データ取得
      const objectFormData = self.searchConfig().parameter[name]

      // input name属性
      let inputName = name
      if(objectFormData.type=='array'){
        // 配列形式
        inputName = inputName + '[]';
      }

      // リセットの時以外
      if(self.resetTime !== true){
        // 件数表示
        self.count(self.getInput());
      }

      // タグフィールド
      const searchSelectTagField = document.getElementById('search-select-tag-field');
      // タグフィールドがある場合
      if(searchSelectTagField){
        // 値
        let value = element.value;
        // 表示ラベル
        let label = element.title;
        // case 'checkbox':
        if(element.checked){
          self.appendSearchTag(name,label,value,element.type)
        }else{
          self.removeSearchTag(name,label,value)
        }
      }
    }
  }

  /* フォーム変更イベント */
  formChange () {
    // 他の関数呼び出し用
    const self = this;
    // データ取得
    const objectFormData = self.searchConfig().parameter

    for (let name in objectFormData) {
      if(typeof self.searchConfig().parameter[name] != undefined){
        // データ取得
        const objectFormData = self.searchConfig().parameter[name]
        // 配列形式
        let inputName = name
        if(objectFormData.type=='array'){
          inputName = inputName + '[]';
        }

        $(document).on('change', '[name="' + inputName + '"]', function () {
          self.occurChangeEvent(name,this);
        });
      }
    }
  }

  /* 入力値取得 */
  getInput() {
    // 他の関数呼び出し用
    const self = this;
    // 検索データ格納変数
    let data = {};
    // 設定データ
    const objectFormData = self.searchConfig().parameter;
    // 設定データ繰り返し処理
    for (let key in objectFormData){
      // name属性の値を作成
      let inputName = '';
      if(objectFormData[key].type=='array'){
        // 配列の場合、[]を追加
        inputName = key + '[]';
      }else{
        inputName = key;
      }
      // 該当のname属性を持つ要素の繰り返し処理
      $('[name^="' + inputName + '"]').each(function (n, e) {
        // タイプで識別
        switch($(e).attr('type')){
          // checkboxタイプ
          case 'checkbox':
            if(e.checked){
              if(objectFormData[key].type=='array'){ // 配列で取得する場合(name=hoge[])
                if(typeof data[key] == 'undefined')data[key]=[];
                data[key].push($(e).val());
              }else{ // 単体で取得する場合(name=hoge)
                data[key]=$(e).val()
              }
            }
            break;
          // textタイプ
          case 'text':
            if($(e).val()){
              data[key]=$(e).val()
            }
            break;
          // その他のタイプ
          default :
            if($(e).val()){
              if(objectFormData[key].type=='array'){ // 配列で取得する場合(name=hoge[])
                if(typeof data[key] == 'undefined')data[key]=[];
                data[key].push($(e).val());
              }else{ // 単体で取得する場合(name=hoge)
                data[key]=$(e).val()
              }
            }
        }
      });
    }

    if(self.map){
      data['b_latitude'] = $('[name=lat1]').val()+'_'+$('[name=lat2]').val();
      data['b_longitude'] = $('[name=lng1]').val()+'_'+$('[name=lng2]').val();
    }

    return data;
  }

  /* isset */
  isset (val) {
    if (typeof (val) === 'undefined') return false;
    if (val === 'undefined') return false;
    return true;
  }
};

export default SearchClass;
